import React from 'react';

// Internals
import { ProviderTypes, TODO } from '../../../types';
import Typography from '../../../components/Typography';

// Antd
import { Avatar, Tabs, Input, Card, List } from 'antd';

// Icons
import { ChevronRight, Search } from 'react-feather';

// Styles
import sharedStyles from './shared.module.scss';
import useProviders from '../../../utils/useProviders';

const { TabPane } = Tabs;

interface SelectProps {
  onSelect: React.MouseEventHandler<HTMLDivElement>;
}

export default function Select({ onSelect }: SelectProps) {
  const { providers } = useProviders();

  const [searchTerm, setSearchTerm] = React.useState('');
  const [activeTab, setActiveTab] = React.useState('all');

  return (
    <div className={sharedStyles['wizard-content']}>
      <Typography type="text_xl" weight="medium" className={sharedStyles.description}>
        Choose the account you want to add
      </Typography>

      <Tabs defaultActiveKey={activeTab} onChange={(activeTabKey) => setActiveTab(activeTabKey)}>
        <TabPane tab="All" key="all"></TabPane>
        <TabPane tab="Custodians" key={ProviderTypes.CUSTODIAN}></TabPane>
        <TabPane tab="Wallets" key={ProviderTypes.WALLET}></TabPane>
        {/* <TabPane tab="Exchanges" key="exchanges"></TabPane> */}
        {/* <TabPane tab="Integrations" key="integrations"></TabPane> */}
      </Tabs>

      <Input
        placeholder="Search..."
        prefix={<Search />}
        size="large"
        className={sharedStyles.search}
        onChange={(e) => setSearchTerm(e.target.value)}
		autoFocus
      />

      <Card className={[sharedStyles.card, 'no-padding'].join(' ')}>
        <List
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={providers.filter(
            (provider) =>
              provider.name.toLowerCase().indexOf(searchTerm) !== -1 &&
              (activeTab === 'all' || activeTab === provider.type),
          )}
          renderItem={(item: TODO, index) => (
            <List.Item className={sharedStyles['list-item']} onClick={() => onSelect(item)}>
              <Avatar size={45} src={item.image} />

              <p className={sharedStyles['list-item__title']}>{item.name}</p>

              <div>
                <ChevronRight />
              </div>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
}
